import * as React from 'react'

export const MOBILE_BREAKPOINT = 768

export function useIsMobile() {
  const [isMobile, setIsMobile] = React.useState<boolean | undefined>(undefined)

  React.useEffect(() => {
    const mql = window.matchMedia(`(max-width: ${MOBILE_BREAKPOINT - 1}px)`)
    const onChange = () => {
      setIsMobile(window.innerWidth < MOBILE_BREAKPOINT)
    }
    mql.addEventListener('change', onChange)
    setIsMobile(window.innerWidth < MOBILE_BREAKPOINT)
    return () => mql.removeEventListener('change', onChange)
  }, [])

  return !!isMobile
}

/** Tailwind's `lg`, the breakpoint the console's rails and tables switch on. */
export const LG_BREAKPOINT = 1024

/**
 * Below `lg`, resolved on the first render rather than in an effect. `useIsMobile`
 * starts false and corrects itself after paint, which is fine for a class but not
 * for something React renders off — a tab strip would paint the wrong orientation
 * and then snap.
 */
export function useIsBelowLg() {
  const query = `(max-width: ${LG_BREAKPOINT - 1}px)`
  const [matches, setMatches] = React.useState(() =>
    typeof window === 'undefined' ? false : window.matchMedia(query).matches
  )

  React.useEffect(() => {
    const mql = window.matchMedia(query)
    const onChange = () => setMatches(mql.matches)
    onChange()
    mql.addEventListener('change', onChange)
    return () => mql.removeEventListener('change', onChange)
  }, [query])

  return matches
}
